import request from '@/libs/request'

// 农机设备 列表
export function agriculturalMachineryListApi (data) {
  return request({
    url: `plant/agriculturalMachinery/list`,
    method: 'get',
    params: data
  })
}

// 农机设备 详情
export function agriculturalMachineryInfoApi (id) {
  return request({
    url: `plant/agriculturalMachinery/read/` + id,
    method: 'get'
  })
}

// 农机设备 同步
export function agriculturalMachinerySyncApi () {
  return request({
    url: `plant/agriculturalMachinery/sync`,
    method: 'post'
  })
}

// 农机设备 所有
export function agriculturalMachineryAllApi () {
  return request({
    url: `plant/agriculturalMachinery/all`,
    method: 'get',
  })
}

